export default "__VITE_ASSET__Cm2CsfNS__"